import Row from '../Row';
import NestedControlBlock from '../NestedControlBlock';
import MarkerIconStyleProvider from '../../../providers/MarkerIconStyleProvider';
import * as ids from '../../../layerIdStrings';

export default [
	{
		component: Row,
		props: {
			id: 'quiz_basic',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_basic',
			name: 'Základný kvíz 1',
			initial: true,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}
	},
	{
		component: Row,
		props: {
			id: 'quiz_basic2',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_basic2',
			name: 'Základný kvíz 2',
			initial: false,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}
	},
	{
		component: Row,
		props: {
			id: 'quiz_basic3',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_basic3',
			name: 'Základný kvíz 3',
			initial: false,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}
	},
	{
		component: Row,
		props: {
			id: 'quiz_zapad',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_zapad',
			name: 'Regionálny kvíz – západné Slovensko',
			initial: false,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}, 
	},
	{
		component: Row,
		props: {
			id: 'quiz_stred',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_stred',
			name: 'Regionálny kvíz – stredné Slovensko',
			initial: false,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}, 
	},
	{
		component: Row,
		props: {
			id: 'quiz_vychod',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_vychod',
			name: 'Regionálny kvíz – východné Slovensko',
			initial: false,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}, 
	},
	{
		component: Row,
		props: {
			id: 'quiz_expert',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			value: 'quiz_expert',
			name: 'Kvíz pre expertov',
			initial: false,
			icon: false,
			inputName: 'quizes',
			inputType: 'radio',
		}, 
	}
/*
		component: Row,
		props: {
			id: ids.DIALECTS_COARSE,
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: ids.DIALECTS_COARSE,
			name: 'Makroareály',
			initial: true,
			icon: false,
			inputName: 'dialects',
			inputType: 'radio',
		}
*/


];
